import React from 'react';
import ReactDOM from 'react-dom';
import '../../App.css'; // 스타일 적용을 위해 필요하다면 import

const PopupAlert = ({ message, onConfirm, onCancel }) => {
    return ReactDOM.createPortal((
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 2000
        }}>
            <div style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '8px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                minWidth: '300px',
                maxWidth: '80%',
                display: 'flex',
                flexDirection: 'column',
                gap: '20px'
            }}>
                <div style={{ 
                    fontSize: '16px', 
                    lineHeight: '1.5',
                    whiteSpace: 'pre-wrap',
                    textAlign: 'center',
                    color: 'var(--color-text-primary, #333)'
                }}>
                    {message}
                </div>
                
                <div style={{ 
                    display: 'flex', 
                    gap: '10px', 
                    justifyContent: 'center' 
                }}>
                    {onCancel && (
                        <button 
                            onClick={onCancel}
                            className="btn-rtg btn-monotone-1"
                            style={{ padding: '8px 20px' }}
                        >
                            취소
                        </button>
                    )}
                    <button 
                        onClick={onConfirm}
                        className="btn-rtg btn-failure "
                        style={{ padding: '8px 20px' }}
                    >
                        확인
                    </button>
                </div>
            </div>
        </div>
    ), document.body);
};

export default PopupAlert;

